export function handleAlert(title, type) {
  this.$root.$emit("alert", { title, type });
}
